module.exports = __webpack_public_path__ + "img/DZ.48f99935.svg";